import React from 'react'
import { Layout } from 'antd'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { ResponsiveHeader } from '../ResponsiveHeader'
import { FooterMultilingualVersionDisplay } from '../../common/MultilingualVersionDisplay'
import './AppLayout.css'

const { Content, Footer } = Layout

interface AppLayoutProps {
    children: React.ReactNode
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const currentYear = new Date().getFullYear()
    const { t } = useTranslation('navigation')
    const location = useLocation()
    const isAuthPage = location.pathname === '/login'

    if (isAuthPage) {
        return <Layout style={{ minHeight: '100vh' }}>{children}</Layout>
    }

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <ResponsiveHeader />

            <Content className="app-layout-content">
                <div className="app-layout-page-surface">{children}</div>
            </Content>

            <Footer style={{ textAlign: 'center' }}>
                {t('brand.footer')} ©{currentYear} | <FooterMultilingualVersionDisplay />
            </Footer>
        </Layout>
    )
}

export default AppLayout
